module.exports = __webpack_public_path__ + "img/landscape-icon.c099fd61.svg";